export {getEventTarget, nodeContains, isFocusWithin, getActiveElement} from '../../../../src/utils/shadowdom/DOMFunctions';
